import { PropsWithChildren, useContext, useEffect } from "react"

import { ClientApi } from "api/client"

import { ClientContext } from "context/ClientContext"
import { UserContext } from "context/UserContext"

const ClientWrapper = ({ children }: PropsWithChildren) => {
  const { cid } = useContext(UserContext)
  const { client, setClient } = useContext(ClientContext)

  useEffect(() => {
    const initializeClient = async () => {
      if (!client && cid) {
        const res = await ClientApi.find({ cid })
        setClient(res)
      }
    }

    initializeClient()
  }, [cid, client, setClient])

  if (!client) {
    return <div></div>
  }

  return children
}

export default ClientWrapper
